import { createTheme } from '@mui/material/styles';
import type { ThemeOptions } from '@mui/material/styles';
import '@mui/x-data-grid/themeAugmentation';
import '@mui/x-date-pickers/themeAugmentation';

import { resolveColors } from './colors';
import { createComponents } from './components';
import { createPalette } from './palette';

// Augment MUI palette to include custom bid/offer colors
declare module '@mui/material/styles' {
  interface Palette {
    ghostWhite: { main: string };
    bid: Palette['primary'];
    offer: Palette['primary'];
    danger: Palette['primary'];
    existingInterest: Palette['primary'];
    contracting: Palette['primary'];
    executed: Palette['primary'];
    navigation: {
      active: string;
    };
    input: {
      background: {
        main: string;
        focused: string;
      };
      border: {
        main: string;
        light: string;
        focused: string;
      };
      placeholder: {
        main: string;
      };
      label: {
        main: string;
      };
    };
    productType: {
      vppa: string;
      ppa: string;
      rec: string;
    };
  }

  interface PaletteOptions {
    ghostWhite?: { main?: string };
    bid?: PaletteOptions['primary'];
    offer?: PaletteOptions['primary'];
    danger?: PaletteOptions['primary'];
    existingInterest?: PaletteOptions['primary'];
    contracting?: PaletteOptions['primary'];
    executed?: PaletteOptions['primary'];
    navigation?: {
      active?: string;
    };
    input?: {
      background?: {
        main?: string;
        focused?: string;
      };
      border?: {
        main?: string;
        light?: string;
        focused?: string;
      };
      placeholder?: {
        main?: string;
      };
      label?: {
        main?: string;
      };
    };
    productType?: {
      vppa?: string;
      ppa?: string;
      rec?: string;
    };
  }

  interface TypeBackground {
    elevated: string;
  }

  interface Transitions {
    base: string;
  }
  interface TransitionsOptions {
    base?: string;
  }
}

const baseTransition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)';

const typography: ThemeOptions['typography'] = {
  fontFamily: '"Inter", monospace',
  h5: {
    fontWeight: 'bold',
  },
  h6: {
    fontWeight: 'bold',
  },
  button: {
    textTransform: 'capitalize',
  },
  subtitle1: {
    fontFamily: '"JetBrains Mono", monospace',
  },
  subtitle2: {
    fontFamily: '"JetBrains Mono", monospace',
  },
};

export const createAppTheme = (darkMode: boolean) => {
  const colors = resolveColors(darkMode);

  return createTheme({
    transitions: {
      base: baseTransition,
    },
    typography,
    palette: createPalette(colors),
    components: createComponents(colors),
  });
};
